import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    color: '#2C2D3E',
    padding: '10px 15px 0px 15px',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },  
  itemsPdfOptions: {
    padding: '10px 15px 25px 15px',
  },
  label: {
    margin: '5px', 
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
  },
  itemFileTypeRow: {
    padding: '10px 15px 25px 15px',
  },  
  itemIdTypeRow: {
    paddingBottom: '25px'
  },
  helperRow: {
    height: '30px',
    paddingTop: '5px',
  },
  errorMessage: {
    display: 'inline',
    fontFamily: 'Roboto',
    color: '#BC0000',
    fontWeight: 400,
    fontSize: '12px',
  }
}));
